import { dayjs } from "@thalamos/common";

export function renderUkDateTime(date: Date, includeTime = false) {
  return dayjs
    .utc(date)
    .tz("Europe/London")
    .format(includeTime ? "DD MMM YYYY - HH:mm" : "DD MMM YYYY");
}
